import { FC } from 'react';

import style from './Requirements.css';

const ITEMS = ['Оперативно отвечайте гостям', 'Работайте честно', 'Получайте хорошие отзывы', 'Не допускайте отмен'];

export const Requirements: FC = () => {
  return (
    <section className={style['requirements']}>
      <div className={style['inner']}>
        <h2 className={style['title']}>Как стать Суперхозяином</h2>
        <div className={style['list']}>
          {ITEMS.map((text, index) => (
            <div key={text} className={style['item']}>
              <div className={style['bullet']}>{index + 1}</div>
              <p className={style['item-text']}>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
